import { render, staticRenderFns } from "./ElaboratedItemList.vue?vue&type=template&id=5af83907"
import script from "./ElaboratedItemList.vue?vue&type=script&lang=js"
export * from "./ElaboratedItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports